
import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import DropinSupervisorBase from "SATPROF_LIBRARY/DropinSupervisor/dropin-supervisor-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
// Comment out any of the following you don't need, to minimize dropin size.
import TimingInfo from 'SATPROF_LIBRARY/DropinSupervisor/timing-info';
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import ThreeFontService from "SATPROF_LIBRARY/DropinSupervisor/services/three-font-service"; // Needed for 3D text
import UniversalRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/universal-render-space"; // For 3D:
// Add any more imports for proxies, etc here:
import Cosmos3_grp from "SATPROF_LIBRARY/Cosmos3/Cosmos3_grp";
import Cosmos3controls_p from "SATPROF_LIBRARY/Cosmos3/Cosmos3controls_p";
import * as THREE from 'three';
import Slider_p from "SATPROF_LIBRARY/Slider/Slider_p"; 

//--------------------------------------------------------------

class ExtendedDropin extends DropinSupervisorBase {

    private animate_rs: AnimateRenderSpace;
    private mystage:any;
    private _dropinName:string = "Orbit16Q"; // Mandatory - must match dropin and folder name
    private _type:string = "?"; // W = widget, Z = zip
    public universal_rs : UniversalRenderSpace;
    public myTimer:TimingInfo;
    //----------------------------------------------------
    // Declare any vars here
    protected cosmos3_grp : Cosmos3_grp;   
    protected controls_p : Cosmos3controls_p; 

    private nLEOconst:number;
    private nBigConst:number;
    //private nMEOconst:number;
    //private nGEOconst:number;
    //private nGEO3const:number;
    private incl_slider_p:Slider_p;
    private RAAN_sldr_p:Slider_p;
    private apogee_sldr_p:Slider_p;
    //private perigee_sldr_p:Slider_p;
    private LEOincl:number = 53;
    //private MEOincl:number = 0;
    //private GEOincl:number = 0;
    private RAAN:number = 0;
    private LEOalt_km:number = 5000;
    //private MEOalt_km:number = 8063;
    //private GEOalt_km:number = 35786;
    private period:number;
    //----------------------------------------------------
    // this is called before onFrameZero as a specific place for registering services.
    // this is necessary because services can make onFrameZero wait while they load things (by design)
    initServices() {
        this.registerService(new ThreeFontService()); // Needed for 3D text anywhere in the whole dropin.
    }
    onFrameZero() {
        super.onFrameZero();

        // add the animate renderspace
        this.animate_rs = new AnimateRenderSpace();
        this.addRenderSpace(this.animate_rs);
        this.animate_rs.setBounds(0,0,1,1);
        this.mystage =  this.animate_rs.exportRootProxy.stageSymbol;

        if (this.isWidget()){
            this._type = "W";
        } else {
            this._type = "Z";
        }
        this.currentStep = 0;
        
        const prev_btn_p = this.animate_rs.exportRootProxy.getProxy("prev_btn", AnimateButtonProxy);
        const next_btn_p = this.animate_rs.exportRootProxy.getProxy("next_btn", AnimateButtonProxy);
        const replay_btn_p = this.animate_rs.exportRootProxy.getProxy("replay_btn", AnimateButtonProxy);
        this.updateStatusText();

        next_btn_p.onPress((e) => {
            if (this.currentStep <this.lastStep){
                this.playStep(this.currentStep+1)
            }
        });

        prev_btn_p.onPress((e) => {
             if (this.currentStep > 0){
                this.playStep(this.currentStep-1)
            }
        });
        replay_btn_p.onPress((e) => {
               this.playStep(this.currentStep)
        });

        this.onChangeStep((requestedStep, currentStep) =>{
            // Handle the calls coming from the Cp nav buttons.
            console.log("In "+this.dropinName+" main.ts,  onChangeStep, requestedStep = "+requestedStep+", currentStep = "+currentStep);
            // logic for whether or not to proceed
            if(requestedStep > this.lastStep){
                return true; // Can't proceed
            } else if(requestedStep <0 ) {
                return true; // Can't proceed
            } else {
                this.playStep(requestedStep)
            }
            return false; // Tell Cp button not to go to another slide
        })
        this.initialize();
        this.updateStatusText();
        console.log("In "+this._dropinName+" main.ts, onFrameZero... ")
        console.log("isWidget = "+this.isWidget());        
    }
    private updateStatusText(){
        this.mystage.status_txt.text = this._dropinName + " ("+this._type+"), step "+this.currentStep+"/"+this.lastStep;
    }
    public onRequestAnimFrame(timingInfo : TimingInfo) {
        //console.log('in onRequestAnimFrame');
        this.doEveryFrame();
    }  
    public set dropinName(name:string){
        this._dropinName = name;
    }
    public get dropinName(){
        return this._dropinName;
    }
    private initialize(){
        //----------------------------------------------------
        //Uncomment this block if you are using any 3D:
        
        // add the 3js renderspace
        //this.universal_rs = new UniversalRenderSpace();
        this.universal_rs = new UniversalRenderSpace(undefined,{logarithmicDepthBuffer:true, antialias:true });        
        
        this.addRenderSpace(this.universal_rs);
        this.universal_rs.setBoundsBaseObject(this.animate_rs.getCanvas());
        
        // Settings for superwide template:
        let anStageWidth:number = 2388; // Stage width (animate_rs)
        let anStageHt:number = 1080; // Stage height
        let can3x:number = 950; //  Upper left corner of universal_rs
        let can3y:number = 50; // Upper left corner of universal_rs (0 is at top)
        let can3w:number = 1400; // Width of universal_rs
        let can3h:number = 900; //Height of universal_rs  

        let can3LLx:number = can3x; // Lower left corner of universal_rs
        let can3LLy:number = can3y + can3h; // Lower left corner of universal_rs (0 is at top)    
        this.universal_rs.setBounds(can3LLx/anStageWidth, (can3LLy-can3h)/anStageHt, 
            can3w/anStageWidth, can3h/anStageHt);
        this.universal_rs.uniCamHandler.pixelSnap = 0.2; // Gives 0.2 deg snap res
        this.universal_rs.uniCamHandler.distance = 150000;
        this.animate_rs.passEventsTo(this.universal_rs);
        this.universal_rs.setZIndex(-1); // Put the 3JS canvas at the back
        
        //----------------------------------------------------
        // Edit init stuff here
        this.lastStep = 8;  // Mandatory
        this.mystage.replay_btn.visible = true; // Optional
        this.myTimer = new TimingInfo();  // A handy timer in case you need it
        this.myTimer.reset();
        //this.myTimer.elapsedTime

        // Add more init stuff here:
        this.cosmos3_grp = new Cosmos3_grp();
        this.universal_rs.myscene.add( this.cosmos3_grp );

        this.controls_p = this.animate_rs.exportRootProxy.getProxy(
        "controls",  // stage symbol instance name (display tree path)
        Cosmos3controls_p,   // Class of the proxy to be created
        {animate_rs:this.animate_rs, 
        universal_rs:this.universal_rs,
        cosmosGroup:this.cosmos3_grp}); // Extra data (not used)
        this.controls_p.showNavControls = true;

        window.addEventListener("COSMOS3_VIEW_CHANGE", this.onViewChange.bind(this));
        this.configureConstellation();

        this.RAAN_sldr_p = this.animate_rs.exportRootProxy.getProxy(
            "orbitControls.RAAN_sldr",  // stage symbol instance name (display tree path)
            Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.RAAN_sldr_p.name = "RAAN_sldr";
        this.RAAN_sldr_p.trackLength = 550;
        this.RAAN_sldr_p.tickInterval = 10;
        this.RAAN_sldr_p.minimum = 0;
        this.RAAN_sldr_p.maximum = 360;
        this.RAAN_sldr_p.value = this.RAAN;
        this.RAAN_sldr_p.snapInterval = 1;
        this.RAAN_sldr_p.enabled = true;

        this.incl_slider_p = this.animate_rs.exportRootProxy.getProxy(
            "orbitControls.incl_slider",  // stage symbol instance name (display tree path)
            Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.incl_slider_p.name = "incl_slider";
        this.incl_slider_p.trackLength = this.RAAN_sldr_p.trackLength;
        this.incl_slider_p.tickInterval = 10;
        this.incl_slider_p.minimum = -110;
        this.incl_slider_p.maximum = 110;
        this.incl_slider_p.value = this.LEOincl;
        this.incl_slider_p.snapInterval = 1;
        this.incl_slider_p.enabled = true;
        window.addEventListener("SLIDERVALUECHANGE", this.onSliderChange.bind(this));

        this.apogee_sldr_p = this.animate_rs.exportRootProxy.getProxy(
            "orbitControls.apogee_sldr",  // stage symbol instance name (display tree path)
            Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.apogee_sldr_p.name = "apogee_sldr";
        this.apogee_sldr_p.trackLength = this.RAAN_sldr_p.trackLength;
        this.apogee_sldr_p.tickInterval = 1000;
        this.apogee_sldr_p.minimum = 0;
        this.apogee_sldr_p.maximum = 50000;
        this.apogee_sldr_p.value = this.LEOalt_km;
        this.apogee_sldr_p.snapInterval = 10;
        this.apogee_sldr_p.enabled = true;
        window.addEventListener("SLIDERVALUECHANGE", this.onSliderChange.bind(this));

        // this.perigee_sldr_p = this.animate_rs.exportRootProxy.getProxy(
        //     "orbitControls.perigee_sldr",  // stage symbol instance name (display tree path)
        //     Slider_p,   // Class of the proxy to be created
        // {animateSpace:this.animate_rs}); // Extra data (not used)
        // this.perigee_sldr_p.name = "perigee_sldr";
        // this.perigee_sldr_p.trackLength = 300;
        // this.perigee_sldr_p.tickInterval = 1000;
        // this.perigee_sldr_p.minimum = 0;
        // this.perigee_sldr_p.maximum = 50000;
        // this.perigee_sldr_p.value = 0;
        // this.perigee_sldr_p.snapInterval = 10;
        // this.perigee_sldr_p.enabled = true;
        // window.addEventListener("SLIDERVALUECHANGE", this.onSliderChange.bind(this));

        this.updateConstellation();    
        //----------------------------------------------------
        this.playStep(0);
    }

    private playStep(step:number){
        //-------------------------------------------------------------------------------------
        // Put code here that runs when each step is entered.
        this.currentStep = step;
        this.updateStatusText();  //  Requires status_txt to be in the stage
        this.animate_rs.exportRoot.gotoAndPlay("Step"+step);  // Controls the playhead
        if (this.isWidget()){
            this.mystage.next_btn.visible = false;
            this.mystage.prev_btn.visible = false;
            this.mystage.replay_btn.visible = false;  
        } else {
            this.mystage.next_btn.visible = (this.currentStep < this.lastStep);
            this.mystage.prev_btn.visible = (this.currentStep > 0);
        } 
        //----------------------------------------------------
        // Do step stuff here

        switch (this.currentStep) {
            case 0:
                this.reset();
                this.mystage.orbitControls.visible = false;
                //this.universal_rs.uniCamHandler.tilt = -90;
                //this.controls_p.currentView = "Site"; 
                break;
            case 1:
                this.reset();
                break;
            case 2:
                this.reset();
                this.incl_slider_p.value = 0;
                break;
            case 3:
                this.reset();
                this.incl_slider_p.value = 90;
                break;
            case 4:
                this.reset();
                this.incl_slider_p.value = 53;
                break;                
            case 5:
            case 6:
            case 7:
                this.reset();
                this.cosmos3_grp.con.showGroup(this.nLEOconst, false);
                this.cosmos3_grp.con.showGroup(this.nBigConst, true);
                this.cosmos3_grp.con.showOrbitPlaneDisc = false;
                this.incl_slider_p.value = 90;
                break;
            case 8:
                this.reset();
                this.cosmos3_grp.con.showGroup(this.nLEOconst, false);
                this.cosmos3_grp.con.showGroup(this.nBigConst, true);
                this.cosmos3_grp.con.showOrbitPlaneDisc = false;
                this.incl_slider_p.value = 90;                
                this.controls_p.currentView = "Site"; 
                break;                   
            default:
                this.reset();
                break;
        }
        this.updateConstellation();
    }
    private reset(){
        console.log("In reset.");
       //----------------------------------------------------
        // Do step reset stuff here
        this.mystage.debug_txt.text = this.universal_rs.uniCamHandler.shortSummary;
        this.controls_p.reset();
        this.cosmos3_grp.resetTimer();
        this.universal_rs.uniCamHandler.pthParentOrbitMode = this.cosmos3_grp.earth; //this.universal_rs.myscene;
        this.controls_p.currentView = "Space"; 
        this.controls_p.setTimeSliderX(200);
        this.mystage.orbitControls.visible = true;
        this.controls_p.showSiteLocationControls = false;
        this.controls_p.showNavControls = false;
        this.cosmos3_grp.con.showGroup(this.nLEOconst, false);

        this.RAAN_sldr_p.value = 177;
        this.apogee_sldr_p.value = 5000;
        this.incl_slider_p.value = 53;
        this.cosmos3_grp.con.showOrbitPlaneDisc = true;

        this.cosmos3_grp.con.showStars = false;
        this.cosmos3_grp.con.showGroup(this.nLEOconst, true);
        this.cosmos3_grp.con.showGroup(this.nBigConst, false);
        this.universal_rs.uniCamHandler.distance = 37000;

        this.updateConstellation();
        //----------------------------------------------------
    }
    private doEveryFrame(){
        //console.log("In doEveryFrame.");
        //----------------------------------------------------
        // Do every frame stuff here.
        this.mystage.debug_txt.text = this.universal_rs.uniCamHandler.shortSummary;

        //----------------------------------------------------       
    }
    private onSliderChange(evt){
        this.updateConstellation();
    }
    private onViewChange(evt){
        //console.log("Received event COSMOS1_VIEW_CHANGE from controls_p");
        this.updateView();
    }
    private updateConstellation(){
        this.LEOalt_km = this.apogee_sldr_p.value;
        this.mystage.orbitControls.apogee_txt.text = this.LEOalt_km+ " km";

        let T_LEO:number = UtilSP.apogeeHeightPerigeeHeight2Period(this.LEOalt_km, this.LEOalt_km);
        let MM_LEO:number =UtilSP.solarDay_sec / T_LEO; // Rev per solar day
        let e:number = 0;
 
        this.period = T_LEO;
        this.cosmos3_grp.con.meanMotionGroup(this.nLEOconst, MM_LEO);
        this.cosmos3_grp.con.eccentricityGroup(this.nLEOconst, e);

        this.RAAN = this.RAAN_sldr_p.value;
        this.cosmos3_grp.con.RAANGroup(this.nLEOconst, this.RAAN);
        this.mystage.orbitControls.RAAN_txt.text = this.RAAN + "°";

        this.LEOincl = -this.incl_slider_p.value;
        this.cosmos3_grp.con.inclinationGroup(this.nLEOconst, this.LEOincl);
        this.mystage.orbitControls.incl_txt.text = this.LEOincl + "°";  

        this.cosmos3_grp.con.inclinationGroup(this.nBigConst, this.LEOincl);
        this.cosmos3_grp.con.meanMotionGroup(this.nBigConst, MM_LEO);


        this.cosmos3_grp.con.setOrbitPlaneDisc(this.LEOincl, this.RAAN, this.LEOalt_km + UtilSP.earthRadiuskm);

        //this.mystage.orbitControls.t_txt.text= 0;
        this.mystage.orbitControls.period_txt.text= ""+(T_LEO/60).toFixed(0)+" min ("+ (T_LEO/3600).toFixed(2)+" hrs)";

    } 
    private configureConstellation(){
        
        this.cosmos3_grp.earth.textureNo = 3;
        this.cosmos3_grp.earth.showBeam = false;
        this.cosmos3_grp.earth.showLatTexts = false;
        this.cosmos3_grp.earth.showLatLines = false;
        this.cosmos3_grp.earth.latLineColor = "orange";
        this.cosmos3_grp.earth.equatorColor = "orange";
        this.cosmos3_grp.earth.longLineColor = "green";
        this.cosmos3_grp.earth.cursorLineLineColor = "purple";
        this.cosmos3_grp.earth.PMColor = "green";
        this.cosmos3_grp.earth.showCursors = false;
        this.cosmos3_grp.earth.showSiteSphere = true;

        this.nLEOconst = this.cosmos3_grp.con.addNewConstellationGroup();
        //this.nLEOconst = this.cosmos3_grp.con.addEllipticalPlanes(1, 48, this.LEOincl, this.LEOalt_km, this.LEOalt_km );
        this.cosmos3_grp.con.configureConstellationAsLEO(this.nLEOconst, 1, 48, this.LEOincl, this.LEOalt_km, this.LEOalt_km);

        this.cosmos3_grp.con.styleGroup(this.nLEOconst,"detailed");
        this.cosmos3_grp.con.sizeGroup(this.nLEOconst, 100);
        this.cosmos3_grp.con.colorGroup(this.nLEOconst, "red");
        this.cosmos3_grp.con.RAANGroup(this.nLEOconst, 20);
        this.cosmos3_grp.con.showAntennasGroup(this.nLEOconst, false);

        this.nBigConst = this.cosmos3_grp.con.addNewConstellationGroup();
        //this.nBigConst = this.cosmos3_grp.con.addEllipticalPlanes(21, 48, this.LEOincl, this.LEOalt_km, this.LEOalt_km );
        this.cosmos3_grp.con.configureConstellationAsLEO(this.nBigConst, 21, 48, this.LEOincl, this.LEOalt_km, this.LEOalt_km);

        this.cosmos3_grp.con.styleGroup(this.nBigConst,"detailed");
        this.cosmos3_grp.con.sizeGroup(this.nBigConst, 100);
        this.cosmos3_grp.con.colorGroup(this.nBigConst, "red");
        this.cosmos3_grp.con.showAntennasGroup(this.nBigConst, false);

        let axesHelper:THREE.AxesHelper = new THREE.AxesHelper( 500000 );
        axesHelper.position.x = 0;
        //this.universal_rs.myscene.add( axesHelper );
        this.universal_rs.uniCamHandler.tilt = 3;
        this.universal_rs.uniCamHandler.pan = 90;
        this.universal_rs.uniCamHandler.distance = 65000;
        this.universal_rs.uniCamHandler.enableTweening = false;
        this.mystage.debug_txt.visible = false;  // Camera status    
    }

    public  updateView(){
        //console.log("In Cosmos1 main.ts showSpaceView = "+this.controls_p.currentView);
        if (this.controls_p.currentView == "AboveEarth" || this.controls_p.currentView == "Space"){
            // Switch to spaceview
            this.cosmos3_grp.con.sizeGroup(this.nLEOconst, 150);
        } else if (this.controls_p.currentView == "Site"){
            // Switch to groundview
            this.cosmos3_grp.con.sizeGroup(this.nLEOconst, 20);
        }
        this.universal_rs.uniCamHandler.pthParentPanTiltMode = this.cosmos3_grp.earth.camHolder;

        if (this.controls_p.currentView == "Space"){
            this.universal_rs.uniCamHandler.pthParentOrbitMode = this.universal_rs.myscene;
            this.universal_rs.backgroundColor = "black";
            this.cosmos3_grp.earth.earth_m.visible = true;
            this.universal_rs.uniCamHandler.orbitMode = true;
            this.universal_rs.uniCamHandler.pan = 225;
            this.universal_rs.uniCamHandler.FOV = 45;            
            this.universal_rs.uniCamHandler.tilt = -17;
            this.universal_rs.uniCamHandler.distance = 93000;
            this.universal_rs.uniCamHandler.lookat = new THREE.Vector3(0,0,0);
            this.cosmos3_grp.earth.setEarthMaterial(true);
        } else if (this.controls_p.currentView == "AboveEarth"){
            this.universal_rs.uniCamHandler.pthParentOrbitMode = this.cosmos3_grp.earth; 
            this.universal_rs.backgroundColor = "black";
            this.cosmos3_grp.earth.earth_m.visible = true;
            this.universal_rs.uniCamHandler.orbitMode = true;
            this.universal_rs.uniCamHandler.pan = 225;
            this.universal_rs.uniCamHandler.FOV = 45;            
            this.universal_rs.uniCamHandler.tilt = -17;
            this.universal_rs.uniCamHandler.distance = 93000;
            this.universal_rs.uniCamHandler.lookat = new THREE.Vector3(0,0,0);
            this.cosmos3_grp.earth.setEarthMaterial(true);
        } else if (this.controls_p.currentView == "Site"){
            this.universal_rs.backgroundColor = "skyblue"; //"blue"; //"skyblue";
            this.cosmos3_grp.earth.earth_m.visible = false;
            this.universal_rs.uniCamHandler.orbitMode = false;
            this.cosmos3_grp.earth.setEarthMaterial(false, "brown");
            //this.cosmos3_grp.earth.siteLat = 45;
            //this.cosmos3_grp.earth.siteLong = 200;
            this.universal_rs.uniCamHandler.pos = new THREE.Vector3(0, 2/1000,0); // Camera 2m above surface
            this.universal_rs.uniCamHandler.pan = 270; // 270 is South
            this.universal_rs.uniCamHandler.tilt = 15;
            this.universal_rs.uniCamHandler.FOV = 100;
        }
        //console.log("Now this._controls_p.currentView = "+this._controls_p.currentView);

    }	
}


export default ExtendedDropin;